import classNames from "classnames"
import { motion } from "motion/react"

import texPng from "../../../assets/img/pv/railing-2-tex.png"
import texWebP from "../../../assets/img/pv/railing-2-tex.webp"
import shadowPng from "../../../assets/img/pv/shadow.png"
import shadowWebP from "../../../assets/img/pv/shadow.webp"
import styles from "./index.module.less"

interface RailingProps {
    position: "left" | "right"
    className?: string
    style?: React.CSSProperties
}

const Railing: React.FC<RailingProps> = (props) => {
    const { position, className, style } = props

    return (
        <motion.div
            initial={{
                transform:
                    position === "left"
                        ? "translateX(-100%)"
                        : "translateX(100%)",
                opacity: 0,
                pointerEvents: "none",
            }}
            animate={{
                transform: "translateX(0)",
                opacity: 1,
                pointerEvents: "auto",
            }}
            transition={{
                duration: 0.5,
                delay: 0.3,
                ease: "easeInOut",
            }}
            className={classNames(styles.railing, styles[position], className)}
            style={style}
        >
            <picture>
                <source srcSet={shadowWebP} type="image/webp" />
                <img src={shadowPng} alt="shadow" />
            </picture>
            <div className={styles.inner}>
                <picture>
                    <source srcSet={texWebP} type="image/webp" />
                    <img src={texPng} alt="tex" />
                </picture>
            </div>
        </motion.div>
    )
}

export default Railing
